const o = {
  id: "OhioPick5",
  logo: !0,
  name: "Pick 5",
  style: {
    colorPrimary: "#fda700"
  }
};
export {
  o as default
};
